/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";


interface Props {
    when: any;
    onOK: () => Promise<boolean>
    onCancel: () => Promise<boolean>;
    title: any;
    okText: any;
    cancelText: any;
}

export function RouterPrompt(props: Props) {
    const { when, onOK, onCancel, title, okText, cancelText } = props;

    const history = useHistory();

    const [currentPath, setCurrentPath] = useState("");
    const [routerSearch, setRouterSearch] = useState("");
    const unblockRef = useRef<any>();

    useEffect(() => {
        if (when && !unblockRef.current) {

            unBlockRouter(); // unblock before block

            unblockRef.current = history.block((prompt) => {
                setCurrentPath(prompt.pathname);
                setRouterSearch(prompt.search);
                return false;
            });
        }

        return () => {
            unBlockRouter();
        };

    }, [history, when]);

    const unBlockRouter = () => {
        if (unblockRef.current) {
            unblockRef.current();
        }
    }

    const handleOK = useCallback(async () => {
        if (onOK) {
            const canRoute = await onOK();
            if (canRoute) {
                unBlockRouter();
                history.push({ pathname: currentPath, search: routerSearch });
            }
        }
    }, [currentPath, history, onOK, routerSearch]);

    const handleCancel = useCallback(async () => {
        if (onCancel) {
            const canRoute = await onCancel();
            if (canRoute) {
                unBlockRouter();
                history.push({ pathname: currentPath, search: routerSearch });
            }
        }
    }, [currentPath, history, onCancel, routerSearch])


    useEffect(() => {
        if (currentPath) {
            Modal.confirm({
                content: title,
                onCancel: () => handleCancel(),
                onOk: () => handleOK(),
                icon: '',
                width: 304,
                okText: okText,
                cancelText: cancelText
            });
        }

    }, [currentPath, routerSearch])


    return <></>;
}